<template>
  <div>
    <el-form ref="form" :model="value" :rules="rules" label-width="90px">
      <el-form-item label="酒店名称" prop="name">
        <el-input v-model="value.name"></el-input>
      </el-form-item>
      <el-form-item label="酒店描述" prop="description">
        <el-input v-model="value.description" type="textarea">
        </el-input>
      </el-form-item>
      <el-form-item label="酒店地址" prop="division">
        <el-cascader
            style="width: 500px;"
            v-model="value.division"
            :options="division"
            :props="{checkStrictly: true}"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="详细地址" prop="divisionDetail">
        <el-input v-model="value.divisionDetail"></el-input>
      </el-form-item>
      <el-form-item label="景区导航" prop="location">
        <baidu-map v-if="!loading" v-model:value="value.location" v-model:preset="value.division"/>
      </el-form-item>
      <el-form-item label="相关图片" prop="pictures">
        <image-uploader :max-count="4" :value="value.pictures"/>
      </el-form-item>
      <div>
        <slot></slot>
      </div>
    </el-form>
    <el-button style="margin-top: 20px;" type="primary" @click="submit" :loading="loading">
      {{ isEdit ? '确认更新' : '确认录入' }}
    </el-button>
  </div>
</template>
<script>
import division from '../../../constants/divisions.json'
import {computed, reactive, ref} from 'vue'
import axios from '../../../request'
import ImageUploader from '../../../components/ImageUploader'
import BaiduMap from "@/components/BaiduMap.vue";

export default {
  props: ['value', 'beforeSubmit', 'afterSubmit'],
  components: {BaiduMap, ImageUploader},
  setup(props) {
    const form = ref('')
    const loading = ref(false)

    const rules = reactive({
      name: [{required: true, message: '必须填写'}],
      pictures: [{
        required: true, message: '至少上传一张图片', validator(rule, value, cb) {
          if (value?.length > 0) {
            cb()
          } else {
            cb('至少上传一张图片')
          }
        }
      }],
      division: [{
        required: true, message: '请选择酒店位置', validator(rule, value, cb) {
          if (value?.length > 0) {
            cb()
          } else {
            cb('请选择酒店位置')
          }
        }
      }],
      location: [{required: true, message: '必须填写'}]
    })

    const isEdit = computed(() => !!props.value.id)

    const submit = () => {
      if(props.beforeSubmit){
        if(props.beforeSubmit() === false){
          return false
        }
      }
      form.value?.validate(pass => {
        if (pass) {
          const pictures = props.value.pictures.map((v)=>{
            if(v.response){
              return v.response.files[0].url
            }
            return v.url
          })
          const data = {
            hotel: {
              ...props.value,
              pictures,
              division: props.value.division.join(',')
            }
          }
          loading.value = true
          axios(isEdit.value ? {
            method: 'patch',
            url: `/hotels/${props.value.id}`,
            data
          } : {
            method: 'post',
            url: '/hotels',
            data
          }).then((res) => {
            props.afterSubmit && props.afterSubmit(res)
          }).finally(() => loading.value = false)
        }
      })
    }

    return {
      form,
      isEdit,
      rules,
      division,
      loading,
      submit
    }
  }
}
</script>
